import {
  SlDivider
} from "./chunk.2P4ISAJG.js";

// src/components/divider/divider.ts
var divider_default = SlDivider;
SlDivider.define("sl-divider");

export {
  divider_default
};
